import { APP_PERMISSIONS } from '@exam-management/permissions';

export const CHANGE_QSET_QUESTION_REQUIRED_PERMISSION = [
  APP_PERMISSIONS.EXAM.QSET.UPDATE,
  APP_PERMISSIONS.EXAM.QCONFIG.VIEW,
  APP_PERMISSIONS.QBANK.QUESTION.VIEW,
];
